import { Component, h, JSX, Prop } from '@stencil/core';
import { SvgService, SvgType } from '../../services';

const defaultHeight = '1rem';

// eslint-disable-next-line no-self-compare
const isInfinityOrNaN = (value: number) => value === Infinity || value !== value;

const isSafeValue = (value?: string): boolean => !!value && !isInfinityOrNaN(parseFloat(value));

@Component({
  tag: 'rcm-icon',
  styleUrl: 'rcm-icon.scss',
  shadow: true,
})
export class RcmIcon {
  /** Icon to be displayed */
  @Prop({ reflect: true }) public icon!: SvgType;

  /**
   * Forced svg height in any css unit ('px', 'rem', ...).
   * The width attribute will be calculated based on this height attribute - no need to set both.
   */
  @Prop({ reflect: true }) public height: string;

  /**
   * Forced svg width in any css unit ('px', 'rem', ...)
   * The height attribute will be calculated based on this width attribute - no need to set both.
   */
  @Prop({ reflect: true }) public width: string;

  @Prop() public color: string;

  @Prop() public containerWidth: string;

  @Prop() public containerHeight: string;

  @Prop() public background: string;

  @Prop() public ariaLabel: string;

  private get heightParsed(): string {
    return isSafeValue(this.height) ? this.height : undefined;
  }

  private get widthParsed(): string {
    return isSafeValue(this.width) ? this.width : undefined;
  }

  private get props(): Record<string, string> {
    const { widthParsed: width, heightParsed: height } = this;
    return !height && !width
      ? {
          height: defaultHeight,
          fill: this.color,
          color: this.color,
        }
      : {
          height,
          width,
          fill: this.color,
          color: this.color,
        };
  }

  public render(): JSX.Element {
    const styleProps: {
      [key: string]: string;
    } = {};
    if (this.background) {
      styleProps.background = this.background;
    }
    if (this.containerHeight) {
      styleProps.height = this.containerHeight;
      styleProps.display = 'flex';
      styleProps.alignItems = 'center';
    }
    if (this.containerWidth) {
      styleProps.width = this.containerWidth;
    }
    return <div class="icon-container" style={{ ...styleProps }} innerHTML={SvgService.getSvg(this.icon, this.props, null, this.ariaLabel)} />;
  }
}
